import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { userAuth, i18n } from '@/core';
import authConfig from './firebaseConfig.json';
import Notifications from 'vue-notification';
import installCustomComponents from './installCustomComponents';
import PortalVue from 'portal-vue';
import VueI18n from 'vue-i18n';
import routeFactory from '@/modules';
import { focusBoundary } from './core/directives';
import { focusNext } from './core/mixins';
import DragDrop from './DragDrop.js';

Vue.config.devtools = true;
Vue.config.productionTip = false;

dom.watch();
library.add(fas);

Vue.use(VueI18n);
Vue.use(PortalVue);
Vue.use(Notifications);
Vue.use(DragDrop);

Vue.directive('focus-boundary', focusBoundary);
Vue.mixin(focusNext);

//Install Evergreen and Timpex Components globaly
installCustomComponents();
userAuth.init(authConfig);
router.addRoutes(routeFactory(router));

let instance = new Vue({
	i18n,
	router,
	store,
	render: h => h(App)
});


try {
	window.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = instance;
} catch (err) {
	console.error('No vue devtools are installed.');
}
instance.$mount('#app');

// After you create app
// You are happy :)